import {BrowserRouter as Router, Routes,Route, useNavigate} from 'react-router-dom';
import {  ForgotPassword, Login, ResetPassword, Settings , Overview, ElectionPeriod, ElectionReport, 
  NomineeReport,
  AccreditationReport,
  CandidateReport,
  NominationApproval,
  Payments,
  ElectoralPosition,
  EventSetup,
  VotingReport,
  ElectionGuideline,ElectionGuideline2,
  EmailTemplate
} from "./screens";

import Layout from "./components/dashboardLayout/main";
import ProtectedRoute from './hooks/protectedRoute';



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      
        
        <Route
          path="/settings/setup/*"
          element={
            <Layout>
              <Routes>
                <Route path="election" element={ <ProtectedRoute><ElectionPeriod /></ProtectedRoute> } />
                <Route path="events" element={ <ProtectedRoute><EventSetup /></ProtectedRoute> } />
                <Route path="electoral-position" element={ <ProtectedRoute><ElectoralPosition /></ProtectedRoute> } />
                <Route path="election-guideline" element={ <ProtectedRoute><ElectionGuideline /></ProtectedRoute> } />
                <Route path="eligible-guidelines" element={ <ProtectedRoute><ElectionGuideline2 /></ProtectedRoute> } />
                <Route path="email-template" element={ <ProtectedRoute><EmailTemplate /></ProtectedRoute> } />
              
              </Routes>
            </Layout>
          }
        />
        <Route
          path="/*"
          element={
            <Layout>
              <Routes> 
                <Route path='/settings' element={ <ProtectedRoute><Settings /></ProtectedRoute> } />
                <Route path="/overview" element={ <ProtectedRoute><Overview /></ProtectedRoute> } />
                <Route path="/election-results-report" element={ <ProtectedRoute><ElectionReport /></ProtectedRoute> } />
                <Route path="/nominee-report" element={ <ProtectedRoute><NomineeReport /></ProtectedRoute> } />
                <Route path="/accreditation-report" element={ <ProtectedRoute><AccreditationReport /></ProtectedRoute> } />
                <Route path="/candidate-report" element={ <ProtectedRoute><CandidateReport /></ProtectedRoute> } />
                <Route path="/nominee-approval" element={ <ProtectedRoute><NominationApproval /></ProtectedRoute> } />
                {/* <Route path='/payments' element={ <ProtectedRoute><Payments /></ProtectedRoute> } /> */}
                <Route path="/voting-report" element={ <ProtectedRoute><VotingReport /></ProtectedRoute> } />
              </Routes>
            </Layout>
          }
        />
      
      </Routes>
    </Router>
  );
}

export default App;
